<template>
  <div class="family-parent-wrapper">
    <div class="role-wrapper">
        <span class="desc">
          当前身份:
          <span class="role">孩子</span>
        </span>
      <van-icon size="36" class="er-code-icon" @click="action_ercode()" name="qr-invalid" />
    </div>

    <div class="content-wrapper" v-for="item in list">
      <p class="title">我的家长</p>
      <div class="info">
        <img :src="item.headImageUrl" alt="" class="user-icon">
        <div class="rg">
          <p class="nicname">昵称: {{item.nickname}}</p>
          <p class="child-id">{{getLansiID(item.userId)}}</p>
        </div>
      </div>

      <van-cell class="cell-wrapper" title="账户充值记录" is-link @click="action_lookReadRecord(item)"/>
    </div>

    <van-button class="learn-flow-btn" plain type="info" @click="action_addParent()">+ 关注家长</van-button>

    <van-popup v-model="show">
      <vue-qr backgroundColor="#fff" :logoSrc="logo" :text="erCode" :size="180"></vue-qr>
    </van-popup>
  </div>
</template>

<script>
  import vueQr from 'vue-qr'
  import wx from "weixin-js-sdk";
  import {getQrcode, getRecognize, getFamily} from "@/api/user";
  import {wxConfigWXApi} from "@/lib/wxShare";
  import {creatLansiId} from "@/lib/util";
  export default {
    data() {
      return {
        list: [],
        show: false, //二维码展示
        erCode: '',
        logo: this.$store.state.user.userInfo.headImageUrl
      }
    },

    components: {
      vueQr
    },

    mounted() {
      if (window.history && window.history.pushState) {
        history.pushState(null, null, document.URL);
        window.addEventListener("popstate", this.goIndex, false);
      }
    },

    destroyed() {
      window.removeEventListener("popstate", this.goIndex, false);
    },

    activated() {
      //每次进入页面去调用微信鉴权,等待鉴权完成才能访问相机扫码功能

      if (navigator.userAgent.indexOf('iPhone') != -1) {//ios
        // wxConfigWXApi(window.location.origin + '/home', () => {
        //   this.$loading.hide()
        // });
      } else {
        this.$loading.show()
        wxConfigWXApi(location.origin + this.$route.fullPath, () => {
          this.$loading.hide()
        })
      }

      this.request_getQrcode()
      this.request_getFamily()
    },

    methods: {
      getLansiID(userId) {
        return creatLansiId(userId)
      },

      // 再测一次
      goIndex() {
        this.$router.replace({path:'/my'})
      },

      //==============action=================
      //关注家长
      action_addParent() {
        let that = this
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: function (res) {
            console.log(res)
            var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
            that.request_getRecognize(result)
          }
        });
      },

      //点击二维码
      action_ercode() {
        this.show = true;
      },

      //点击转移记录
      action_lookReadRecord(item) {
        this.$router.push( {path: './parentPayReocord', query: {parentId: item.userId, nickname: item.nickname}})
      },

      //===============net==============
      //获取亲自列表
      request_getFamily(){
        // this.$loading.show()
        let params = {
          pageIndex: 0,
          pageSize: 20
        }
        getFamily(params).then(res => {
          // this.$loading.hide()
          if (res.code == 0){
            this.list = res.data.records;
          }else {
            this.$toast({
              message: res.msg,
              duration: 1000
            })
          }
        })
      },

      //获取个人二维码
      request_getQrcode() {
        getQrcode().then(res => {
          if (res.code == 0){
            this.erCode = res.data;
          }else {
            this.$toast({
              message: res.msg,
              duration: 1000
            })
          }
        })
      },

      //识别用户二维码
      request_getRecognize(result) {
        this.$loading.show()
        let params = {
          content: result
        }
        getRecognize(params).then(res => {
          this.$loading.hide()
          if (res.code == 0){
            // {
            //   "headImageUrl": "xyz.jpg",
            //   "nickname": "昵称",
            //   "roleType": 1,
            //   "userId": 11
            // }
            const result = JSON.stringify(res.data)
            this.hanleScanResult(1, result)
          }else {
            this.$toast({
              message: res.msg,
              duration: 1000
            })
          }
        })
      },

      //处理扫描结果
      hanleScanResult(tag, result) {//tag: 0 添加孩子  1 添加家长
        console.log(result)
        if (tag == 0){
          this.$router.push({path: '/scanAddChild', query:{qrcodeResult: result}})
        }else {
          this.$router.push({path: '/scanAddParent', query:{qrcodeResult: result}})
        }
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import "../stylesheet/common.styl"
  .family-parent-wrapper{
    box-sizing: border-box;
    height: 100vh;
    padding: 16px 12px;
    background-color : #fcfcfc;
  }

  .role-wrapper{
    padding: 8px 10px;
    border: 1px solid $common-line-color;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    .er-code-icon {
      width: 36px;
      height: 36px;
    }
  }

  .content-wrapper{
    margin-top: 12px;
    padding: 8px 10px;
    border: 1px solid $common-line-color;
    border-radius: 6px;
    .info{
      margin-top: 4px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #F5F6F7;
      padding: 16px 10px;
      border-radius: 6px;
      .user-icon{
        margin-right: 10px;
        width: 60px;
        height: 60px;
        border-radius: 50px;
      }
      .rg{
        flex: 1;
        .nicname{
          margin-bottom: 4px;
        }
      }
    }
  }

  .learn-flow-btn {
    width: 100%;
    border-radius: 50px;
    margin-top: 16px;
    margin-bottom: 70px;
    background-color: $common-blue;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// app/pages/family/FamilyChild.vue